"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortFieldSchema = void 0;
const zod_1 = require("zod");
exports.sortFieldSchema = zod_1.z.enum(["subject", "number", "status", "receivedDate", "dueDate", "modifiedOn"]);
//# sourceMappingURL=sortField.schema.js.map